"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _sanitize = require("../utils/sanitize");
var _useEnhancedHref = _interopRequireDefault(require("../../../hooks/useEnhancedHref"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ExternalLink = exports.ExternalLink = function ExternalLink(_ref) {
  var _ref$componentName = _ref.componentName,
    componentName = _ref$componentName === void 0 ? '' : _ref$componentName,
    _ref$section = _ref.section,
    section = _ref$section === void 0 ? '' : _ref$section,
    url = _ref.url,
    title = _ref.title,
    _ref$newTab = _ref.newTab,
    newTab = _ref$newTab === void 0 ? false : _ref$newTab;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      href: (0, _useEnhancedHref["default"])(encodeURI(url)),
      target: newTab ? '_blank' : undefined,
      rel: newTab ? 'noopener noreferrer' : undefined,
      "data-event": "ctaClick",
      "data-location": "External",
      "data-component": componentName,
      "data-section": (section === null || section === void 0 ? void 0 : section.replace(/ /g, '')) || '',
      children: (0, _sanitize.sanitize)(title)
    })
  });
};